import { useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Home, CheckCircle } from "lucide-react";

export default function ApplicationSubmittedPage() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleDismiss = () => {
    // Log the user out
    logout();
    // Navigate to login page
    navigate("/login");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4" data-testid="application-submitted-page">
      <div className="w-full max-w-lg animate-fade-in">
        {/* Logo/Brand */}
        <div className="flex items-center gap-3 mb-8 justify-center">
          <div className="w-12 h-12 rounded-xl bg-primary flex items-center justify-center">
            <Home className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-primary">WilyRash Homes</h1>
            <p className="text-sm text-text-muted">Tenant Management System</p>
          </div>
        </div>

        <Card className="border-stone-200 shadow-lg">
          <CardContent className="pt-8 pb-8">
            <div className="text-center">
              {/* Success Icon */}
              <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-6">
                <CheckCircle className="w-10 h-10 text-green-600" />
              </div>

              {/* Thank You Message */}
              <h2 className="text-2xl font-bold text-primary mb-4">Application Submitted!</h2>
              
              <div className="bg-stone-50 rounded-xl p-6 mb-6 text-left">
                <p className="text-text-main leading-relaxed">
                  Thank you for submitting your Application. Your application will be reviewed and if you are approved, 
                  <strong> Wilyrash Homes</strong> will send you a message notifying you of the outcome and a new login 
                  credentials as well as instructions on the next step towards your tenancy.
                </p>
              </div>

              <p className="text-sm text-text-muted mb-6">
                Please click the button below after reading this message. You will be logged out automatically.
              </p>

              <Button 
                onClick={handleDismiss}
                className="w-full h-12 rounded-full bg-primary hover:bg-primary-800 text-white font-medium"
                data-testid="dismiss-btn"
              >
                Dismiss
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
